// extracted by mini-css-extract-plugin
module.exports = {"pt-hospital-table":"pt-hospital-table-19ced0ddcb91a92fb7e1da0653268a21","download-qrcode":"download-qrcode-5d880f6f68a0b599977bf83a4cfa29df"};